import {gql} from '@apollo/client'

export const GetPaymentMethods = gql`
    query GetPaymentMethods {
        paymentMethodsFind {
            id
            name
        }
    }
`